// extracted by mini-css-extract-plugin
module.exports = {"container":"NavMenuList_container__cEsX7","visuallyHidden":"NavMenuList_visuallyHidden__1UBn7"};